import { render } from "./section_3.vue?vue&type=template&id=c2f35090"
import script from "./section_3.vue?vue&type=script&lang=js"
export * from "./section_3.vue?vue&type=script&lang=js"

import "./section_3.vue?vue&type=style&index=0&id=c2f35090&lang=css"
script.render = render

export default script